// Recovered compiled webpack factory 52273. Edit this function expression; run npm run build.
(e) => {
  e.exports = {
    theme: "skeuo_theme__ndEbj",
    cta: "skeuo_cta__A7AN8",
    key: "skeuo_key__oVi6S",
    pill: "skeuo_pill__M3Cxj",
    pillOn: "skeuo_pillOn__YZxQG",
    segmented: "skeuo_segmented__2ha0A",
    segment: "skeuo_segment__aVxjA",
    segmentOn: "skeuo_segmentOn__Q5t4O",
    field: "skeuo_field__L9fJg",
  };
}
